'use client'

import { useEffect, useRef } from 'react'

import { CustomerInfo } from 'app/utils/authentication'

import { analytics } from './segment'

export const useAnalyticsAuth = (customerInfo: CustomerInfo): void => {
  const prevUserId = useRef<number | null>(null)

  useEffect(() => {
    const run = async () => {
      const user = await analytics.user()
      const userId = user.id()

      if ((userId ?? '') !== (customerInfo.customer?.id ?? '')) {
        console.log('[Segment] Resetting because saved user id not equal to logged in')
        await analytics.reset()
        prevUserId.current = null
      }

      if (!customerInfo.customer?.id && prevUserId.current) {
        console.log('[Segment] Resetting after logout')
        await analytics.reset()
        prevUserId.current = null
        return
      }

      if (customerInfo.customer?.id && customerInfo.customer.id !== prevUserId.current) {
        console.log('[Segment] Identifying user', customerInfo)
        analytics.identify(customerInfo.customer.id.toString(), {
          name: customerInfo.customer.fullName,
          email: customerInfo.customer.email,
          phone: customerInfo.customer.phoneNumber,
          organizationId: customerInfo.organization?.id,
          organizationOfficialId: customerInfo.organization?.officialId,
        })
        prevUserId.current = customerInfo.customer.id
      }
    }

    run()
  }, [customerInfo])
}
